import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  Avatar,
  Grid,
} from "@mui/material";
import { Email, Phone, Badge, Lock, Business } from "@mui/icons-material";
import { Button } from "@/components/ui";
import { useAuthStore } from "@/store/authStore";

/**
 * Page Mon compte — informations du profil utilisateur
 */
export function AccountPage(): JSX.Element {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return <></>;
  }

  const displayName = [user.firstName, user.lastName].filter(Boolean).join(" ") || "Utilisateur";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box>
        <Typography variant="h1" sx={{ fontSize: "1.75rem", fontWeight: 700, mb: 0.5 }}>
          Mon compte
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Consultez et gérez vos informations personnelles.
        </Typography>
      </Box>

      <Card sx={{ p: 4, maxWidth: 560 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3, mb: 4 }}>
          <Avatar
            sx={{
              width: 64,
              height: 64,
              bgcolor: "primary.main",
              fontSize: "1.5rem",
            }}
          >
            {user.firstName?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || "?"}
          </Avatar>
          <Box>
            <Typography variant="h3" sx={{ fontSize: "1.25rem", fontWeight: 600 }}>
              {displayName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.role}
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Email sx={{ color: "text.secondary", fontSize: 20 }} />
              <Box>
                <Typography variant="caption" color="text.secondary">
                  Email
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {user.email}
                </Typography>
              </Box>
            </Box>
          </Grid>
          {user.phone && (
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Phone sx={{ color: "text.secondary", fontSize: 20 }} />
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Téléphone
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {user.phone}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Badge sx={{ color: "text.secondary", fontSize: 20 }} />
              <Box>
                <Typography variant="caption" color="text.secondary">
                  Rôle
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {user.role}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: "divider", display: "flex", flexWrap: "wrap", gap: 2 }}>
          <Button
            variant="outline"
            startIcon={<Lock />}
            onClick={() => navigate("/password-reset")}
          >
            Changer le mot de passe
          </Button>
          {user.enterprise?.id && user.role === "ADMIN" && (
            <Button
              variant="outline"
              startIcon={<Business />}
              onClick={() => navigate("/society")}
            >
              Modifier la fiche société
            </Button>
          )}
        </Box>
      </Card>
    </Box>
  );
}
